module.exports = __webpack_public_path__ + "img/bn_e.3514d668.png";